module.exports = __webpack_public_path__ + "img/img_delivery_quick_negative.deeb5ae.png";